<template>
  <client-only>
  <div class="full-page-wrapper register-page">
    <OtherPageHeader activeSection="welcome-to-artfield"></OtherPageHeader>
    <feed-preview v-show="show" style="z-index: 0;"></feed-preview>
    <div class="flex h-screen flex-col justify-center items-center feed-overlay red-gradient-bg">
      <div class="confirm-text ap54 pb-10">
        Welcome to Artfield. Start your journey<br/> by creating your talent profile.
      </div>
        <div class="create-button" @click="next">Create Account</div>
      </div>
    </div>
  </client-only>
</template>

<script setup lang="ts">
import OtherPageHeader from "~/components/layout/OtherPageHeader.vue";
import {useRoute, useRouter} from "vue-router";
import {computed, onMounted, ref} from "vue";
import FeedPreview from "~/components/FeedPreview.vue";
import {getUniqueCode} from "~/api/authApi";
import type {UserMinimal} from "~/types/types";

const route = useRoute();
const router = useRouter();
const userData = ref<UserMinimal | any>(null);

// Add meta title and description
useHead({
  title: "Sign up",
  meta: [
    {
      name: "description",
      content: "Sign up for a free account to access all features.",
    },
    {
      property: "og:title",
      content: "Sign up",
    },
    {
      property: "og:description",
      content: "Sign up for a free account to access all features.",
    }
  ]
});

const show = ref(false);
const code = ref<any>(route.query.code as string || null);

const next = async () => {
  if (!code.value) {
    userData.value = await getUniqueCode();
    code.value = userData.value.uniqueCode;
  }
  await router.push(`/permissions?code=${code.value}`);
}
onMounted(async () => {
  if (process.client) {
    setTimeout(async () => {
      show.value = true;
    }, 500)
  }
})
</script>

<style scoped>

.confirm-text {
  z-index: 4;
  padding-bottom: 30px;
}

@media (max-width: 768px) {
  .register-page .feed-overlay {
    padding: 0 24px;
  }

  .confirm-text {
    font-size: 24px !important;
    line-height: 1.3 !important;
    padding: 0 0 24px 0;
  }

  .confirm-text br {
    display: block;
  }

  .create-button {
    width: 100% !important;
    max-width: 280px;
    padding: 14px 24px !important;
    font-size: 14px;
  }
}

</style>